import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
// HOCs
import withFormManagement from 'hocs/WithFormManagement';
import withStateReinit from 'hocs/WithStateReinit';
// Core components
import Callout from 'components/misc/Callout';
import Card from 'components/core/Card';
import Divider from 'components/core/Divider';
import Link from 'components/core/Link';
import List from 'components/core/List';
import TextField from 'components/core/TextField';
import Typography from 'components/core/Typography';
// Custom
import { EmailItem, PhoneNumberItem } from 'components/items/InformationItems';
import { cpmCarparkDataShape, cpmOnDemandAccessDataShape, errorShape } from 'constants/PropTypesShapes';
import { buildFormErrors, cpmOnDemandAccessTerminateConstraints } from 'utils/Forms';
import FormDialogTemplate from 'components/templates/FormDialogTemplate';
import FormHelper from 'components/misc/FormHelper';
import { formatPhoneNumber } from 'utils/Tools';

class OnDemandTerminateForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleValidate = this.handleValidate.bind(this);
  }

  componentDidMount() {
    // We need to pass component reference to parent (= DialogItem)
    const { onRef } = this.props;
    onRef(this);
  }

  // Handlers called by parent (= DialogItem)
  handleValidate() {
    const {
      onDemand,
      fields: { comments },
      onErrorsChange,
      onValidate,
    } = this.props;

    const errors = buildFormErrors({ comments }, cpmOnDemandAccessTerminateConstraints);

    // Apply errors
    onErrorsChange(errors);

    // No error => validate form
    if (!errors) {
      onValidate(onDemand, { comments });
      return true;
    }

    return false;
  }

  render() {
    const {
      carpark,
      countryCode,
      fields: { comments },
      errors,
      onFieldsChange,
    } = this.props;

    const hasCarparkContactEmail = !_isNil(carpark.contact.email);
    const hasCarparkContactPhone = !_isNil(carpark.contact.phone);
    const hasCarparkContact = hasCarparkContactEmail || hasCarparkContactPhone;

    return (
      <FormDialogTemplate errors={errors}>
        <div className="row">
          <div className="col-12">
            <Card
              title={(
                <Typography type="subtitle2">
                  <LocalizedMessage id="title.carparkContact" />
                </Typography>
              )}
              contentOptions={{
                expandable: true,
                expanded: true,
              }}
            >
              {hasCarparkContact ? (
                <List disablePadding>
                  {hasCarparkContactEmail && (
                    <EmailItem
                      light
                      value={<Link mailto={carpark.contact.email}>{carpark.contact.email}</Link>}
                    />
                  )}
                  {hasCarparkContactEmail && hasCarparkContactPhone && (
                    <Divider variant="middle" />
                  )}
                  {hasCarparkContactPhone && (
                    <PhoneNumberItem
                      light
                      value={(
                        <Link tel={carpark.contact.phone}>
                          {formatPhoneNumber(carpark.contact.phone, countryCode)}
                        </Link>
                      )}
                    />
                  )}
                </List>
              ) : (
                <Callout severity="warning">
                  <LocalizedMessage id="info.carparkContactEmpty" />
                </Callout>
              )}
            </Card>
          </div>
          <div className="col-12 pt-3">
            <div className="d-flex">
              <FormHelper
                elements={[
                  {
                    content: (
                      <LocalizedMessage id="help.onDemand.terminateComments" />
                    ),
                  },
                ]}
              />
              <div style={{ flex: 1 }}>
                <Card>
                  <div className="row">
                    <div className="col-12 col-lg-9">
                      <TextField
                        label={<LocalizedMessage id="field.comments" />}
                        value={comments}
                        required
                        errorText={_get(errors, 'comments')}
                        onChange={(value) => onFieldsChange({ comments: value })}
                      />
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </FormDialogTemplate>
    );
  }
}

OnDemandTerminateForm.propTypes = {
  carpark: cpmCarparkDataShape.isRequired,
  countryCode: PropTypes.string.isRequired,
  onDemand: cpmOnDemandAccessDataShape.isRequired,
  operationError: errorShape, // eslint-disable-line react/no-unused-prop-types
  fields: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onFieldsChange: PropTypes.func.isRequired,
  onErrorsChange: PropTypes.func.isRequired,
  onRef: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
};

OnDemandTerminateForm.defaultProps = {
  operationError: null,
  errors: null,
};

const mapFieldsToProps = {
  comments: { defaultValue: '' },
};

const mapOwnPropsToResources = (ownProps) => ({
  resourceData: ownProps.onDemand,
  operationError: ownProps.operationError,
});

const mapStateToProps = (state) => ({
  operationError: state.cpmCarparkOnDemand.terminate.error,
});

module.exports = compose(
  connect(mapStateToProps),
  withFormManagement(mapFieldsToProps, mapOwnPropsToResources, false),
  withStateReinit(['terminateCarparkOnDemand']),
)(OnDemandTerminateForm);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/onDemand/OnDemandTerminateForm.js